import { Alert, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Stack, TextField, Typography } from "@mui/material";
import axios from "axios";
import { Html5QrcodeScanner } from "html5-qrcode";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import {QRCodeCanvas} from 'qrcode.react';
import { useNavigate } from "react-router";
import HintDialog, { OPEN_HINT_DIALOG } from "../Component/HintDialog";
import PubSub from "pubsub-js";

export const sessionOptions = [
  {label: '金剛力灌頂', _id: 1}, 
  {label: '時輪金剛灌頂、大鵬金翅鳥灌頂', _id: 2}, 
  {label: '時輪金剛、香巴拉與世界和平國際論壇', _id: 3}, 
  {label: '篤布巴暨時輪九尊世界和平祈福大法會', _id: 4}]

function Home () {
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [img, setImg] = useState(null);
  const {handleSubmit, register, formState: {errors}} = useForm();
  const Ref = useRef();
  const navigate = useNavigate();

  const onOpen = () => {
    setOpen(true);
  }

  const onClose = () => {
    setOpen(false);
  }

  const onSend = handleSubmit(async (data) => {
    const session = sessionOptions.find(({label}) => label === data.session);
    const params = {name: data.name, phone: data.phone, _session_id: session._id};
    const passData = {api: 'user_session', action: 'checkInWithSubmit', ...params};
    const url = process.env.NODE_ENV === 'development' ? `http://${document.location.hostname}/check-in/public/api/` : '/api/';
    const response = await axios.post(url, passData);
    if (response.data.data && typeof response.data.data === 'string') {
      const content = <>
      <Paper sx={{p: 2}}>
        <Typography>{response.data.data}</Typography>
      </Paper>
      </>
      PubSub.publish(OPEN_HINT_DIALOG, content);
      return;
    }
    const labelData = {};
    response.data.data.data.forEach((r, i) => {
      labelData[response.data.data.columns[i]] = r;
    })
    const content = <>
    <Paper sx={{p: 2}}>
      <Typography>姓名: {labelData.name}</Typography>
      <Typography>電話: {labelData.phone}</Typography>
      <Typography>報到時間: {labelData.check_in_time}</Typography>
      <Typography>活動: {labelData.session_name}</Typography>
      <Typography>人數: {labelData.person_count}</Typography>
      {labelData.person_count > 1 && <Typography>陪同人員: {labelData.accompany}</Typography>}
    </Paper>
    </>
    PubSub.publish(OPEN_HINT_DIALOG, content);
  })

  return (
    <>
      {error && <Alert severity="error">{error}</Alert>}
      <Button onClick={() => navigate('/list')}>報到列表</Button>
      <Button onClick={() => navigate('/import')}>設定</Button>
      <Stack sx={{
        display: 'flex',
        justifyContent: 'center', // 水平置中
      }}>
        <Box fontSize={50}>報到姓名:</Box> 
        <TextField {...register('name', { required: true })} type="text" helperText={errors?.name ? '必填' : ''} error={Boolean(errors?.name)}/>
        <Box fontSize={50}>手機末三碼:</Box> 
        <TextField {...register('phone', { required: true })} type="text" helperText={errors?.phone ? '必填' : ''} error={Boolean(errors?.phone)}/>
        <Box fontSize={50}>報到場次:</Box> 
        <Autocomplete options={sessionOptions} renderInput={(params) => <TextField {...params} {...register('session', { required: true })}  helperText={errors?.session ? '必填' : ''} error={Boolean(errors?.session)}/>}/>
        <Button onClick={onSend} variant="contained">送出</Button>
        <Box>
          <Button onClick={onOpen}>掃描QrCode</Button>
        </Box>
      </Stack>
      {/* <QRCodeCanvas value={"https://reactjs.org/"} /> */}
      {/* {img && <img src={img} alt="QR Code" />} */}
      <QrCodeScannerDialog {...{open, onClose, setError, Ref}}/>
      <HintDialog title={'報名成功'}/>
    </>
  )
}

function QrCodeScannerDialog({open, onClose, setError, Ref}) {
  const lastCodeRef = useRef("");
  const lastTimeRef = useRef(0);

  const handleQrCodeSuccess = async (decodedText) => {
    const now = Date.now();
    if (typeof decodedText !== 'string' || !/^[a-f0-9]{32}$/.test(decodedText)) return;
    if (decodedText === lastCodeRef.current && now - lastTimeRef.current < 2000) {
      return;
    }
    console.log("QR Code scanned:", decodedText);
    const params = {qr_token: decodedText};
    const passData = {api: 'user_session', action: 'checkIn', ...params};
    const url = process.env.NODE_ENV === 'development' ? `http://${document.location.hostname}/check-in/public/api/` : '/api/';
    const response = await axios.post(url, passData);
    lastCodeRef.current = decodedText;
    lastTimeRef.current = now;
    if (response.data.data && typeof response.data.data === 'string') {
      // setError(response.data.data);
      // onClose();
      const content = <>
      <Paper sx={{p: 2}}>
        <Typography>{response.data.data}</Typography>
      </Paper>
      </>
      PubSub.publish(OPEN_HINT_DIALOG, content);
      return;
    }
    const labelData = {};
    response.data.data.data.forEach((r, i) => {
      labelData[response.data.data.columns[i]] = r;
    })
    const content = <>
    <Paper sx={{p: 2}}>
      <Typography>姓名: {labelData.name}</Typography>
      <Typography>電話: {labelData.phone}</Typography>
      <Typography>報到時間: {labelData.check_in_time}</Typography>
      <Typography>活動: {labelData.session_name}</Typography>
      <Typography>人數: {labelData.person_count}</Typography>
      {labelData.person_count > 1 && <Typography>陪同人員: {labelData.accompany}</Typography>}
    </Paper>
    </>
    PubSub.publish(OPEN_HINT_DIALOG, content);
    
    // onClose(); // Close the dialog after successful scan
  };

  const handleQrCodeError = (errorMessage) => {
    // console.error("QR Code error:", errorMessage);
  };

  return (
    <>
      <Dialog fullScreen open={open} onClose={onClose} ref={Ref}>
        <DialogTitle>
          掃描QrCode
        </DialogTitle>
        <DialogContent>
          <QrCodeScanner onScanSuccess={handleQrCodeSuccess} onScanError={handleQrCodeError}/>
          <Box display={"flex"} justifyContent="center">
            <Button onClick={onClose}>關閉</Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}

function QrCodeScanner({ onScanSuccess, onScanError}) {
  const qrcodeRegionId = "qr-code-reader"; // Unique ID for the scanner's div

  useEffect(() => {
    const scanner = new Html5QrcodeScanner(
      qrcodeRegionId,
      { fps: 10, qrbox: {width: 200, height: 200}, aspectRatio: 1.333},
      false // verbose
    );

    scanner.render(onScanSuccess, onScanError);

    return () => {
      scanner.clear().catch(error => {
        console.error("Failed to clear html5QrcodeScanner:", error);
      });
    };
  }, [onScanSuccess, onScanError]);

  return <div id={qrcodeRegionId} />
};

export default Home;